import React, { useContext } from 'react'
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap'
import userIcon from '../../assets/icons/user-icon-menu.svg';
import './sidebar.css';
import { t } from 'i18next';
import { getDataUserByKey, getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers';
import SidebarOption from './SidebarOption';
import { havePermission } from "../../helpers/helpers";
import { sidebarMenu } from './sidebarMenu';
import useWindowSize from '../../customHooks/useWindowSize';
import { logout } from '../../services/login';
import InstanceContext from '../../context/InstanceContext/InstanceContext';

const Sidebar = ({ isOpen, setIsOpen }) => {

    const { isReadyForInstall, downloadApp } = useContext(InstanceContext)

    const profile_id = getDataUserByKey('access_profile_id');
    const isGuard = Number(profile_id) === 3;

    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');

    const haveAccessBuildings = getTenantInfoByKey('is_building');

    const fullName = `${getDataUserByKey('first_name')} ${getDataUserByKey('last_name')}`;

    const isVisible = (permissions) => permissions.length === 0 ? true : permissions.some(permission => havePermission(permission));

    const { windowWidth } = useWindowSize();

    const logoutOpt = {
        "key": "LOGGOUT",
        "icon": 'loggout-icon.svg',
        "onClick": () => logout(),
        "onScreen": '',
        "isVisibleFor": []
    };

    const downloadAppOpt = {
        "key": "DOWNLOAD_APP",
        "icon": windowWidth <= 576 ? 'download-app-phone.svg' : 'download-app-desktop.svg',
        "onClick": () => downloadApp(),
        "onScreen": '',
        "isVisibleFor": []
    };

    return (
        <Offcanvas
            isOpen={isOpen}
            direction="end"
            toggle={setIsOpen}
        >
            <OffcanvasHeader>
                <div className='d-flex'>
                    <div className='me-2'>
                        <img src={userIcon} alt="profile" />
                    </div>
                    <div className=''>
                        <p className='m-0 hello-txt'>{t('HELLO')}</p>
                        <p className='m-0 fullname-txt'>{fullName}</p>
                        {isGuard && (
                            <>
                                {haveAccessOpenings && (
                                    <p className='m-0 subtitle'>{getUserOpening()?.descripcion}</p>
                                )}
                                {haveAccessBuildings && (
                                    <p className='m-0 subtitle'>{getUserBuilding()?.buildingDescription}</p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </OffcanvasHeader>
            <OffcanvasBody>
                {
                    sidebarMenu.map((sidebarOption, idx) =>
                        isVisible(sidebarOption.isVisibleFor) && (
                            <SidebarOption
                                key={idx}
                                closeSidebar={() => setIsOpen(false)}
                                sidebarOption={sidebarOption}
                            />
                        )
                    )
                }
                {isReadyForInstall && (
                    <SidebarOption
                        closeSidebar={() => setIsOpen(false)}
                        sidebarOption={downloadAppOpt}
                    />
                )}
                <SidebarOption
                    closeSidebar={() => setIsOpen(false)}
                    sidebarOption={logoutOpt}
                />
            </OffcanvasBody>
        </Offcanvas >
    )
}

export default Sidebar